<!--智能预测-->
<template>
  <div>

    <div class="all-left-top-box">
      <a-row  :gutter="[16,8]">
        <a-col :span="6">
          <a-card >
            <div class="e-card-single-box">
              <img src="../../../../img/srongjieyang.png" alt="" class="e-img-wh">
              <div class="e-card-text-box">
                <div>溶解氧</div>
                <div class="e-card-text-blue"><span class="e-card-text-big">75</span>mg/L</div>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :span="6">
          <a-card >
            <div class="e-card-single-box">
              <img src="../../../../img/sshuiwei.png" alt="" class="e-img-wh">
              <div class="e-card-text-box">
                <div>水温</div>
                <div class="e-card-text-blue"><span class="e-card-text-big">36.2</span>℃</div>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :span="6">
          <a-card >
            <div class="e-card-single-box">
              <img src="../../../../img/syulv.png" alt="" class="e-img-wh">
              <div class="e-card-text-box">
                <div>余氯</div>
                <div class="e-card-text-blue"><span class="e-card-text-big">0.3</span>mg/L</div>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :span="6">
          <a-card >
            <div class="e-card-single-box">
              <img src="../../../../img/sshuiwei.png" alt="" class="e-img-wh">
              <div class="e-card-text-box">
                <div>水位</div>
                <div class="e-card-text-blue"><span class="e-card-text-big">75</span>m</div>
              </div>
            </div>
          </a-card>
        </a-col>

        <a-col :span="6">
          <a-card >
            <div class="e-card-single-box">
              <img src="../../../../img/sdianya.png" alt="" class="e-img-wh">
              <div class="e-card-text-box">
                <div>电压</div>
                <div class="e-card-text-blue"><span class="e-card-text-big">75</span>mv</div>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :span="6">
          <a-card >
            <div class="e-card-single-box">
              <img src="../../../../img/ssuanjian.png" alt="" class="e-img-wh">
              <div class="e-card-text-box">
                <div>酸碱度</div>
                <div class="e-card-text-blue"><span class="e-card-text-big">7</span></div>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :span="6">
          <a-card >
            <div class="e-card-single-box">
              <img src="../../../../img/swendu.png" alt="" class="e-img-wh">
              <div class="e-card-text-box">
                <div>溶解氧</div>
                <div class="e-card-text-blue"><span class="e-card-text-big">36.1</span>℃</div>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :span="6">
          <a-card >
            <div class="e-card-single-box">
              <img src="../../../../img/sandan.png" alt="" class="e-img-wh">
              <div class="e-card-text-box">
                <div>氨氮值</div>
                <div class="e-card-text-blue"><span class="e-card-text-big">9</span>ppm</div>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :offset="23" :span="1"><a-button type="link">更多</a-button></a-col>

      </a-row>
    </div>

    <a-card class="all-left-top-box">
      <div>
        <a-row type="flex" justify="space-around" align="middle">
          <a-col :span="19"><div class="yc-title">预测</div></a-col>
          <a-col :span="3"><div><a-time-picker use12-hours /></div></a-col>
          <a-col :span="2"><a-button type="primary">确定</a-button></a-col>
        </a-row>
      </div>

      <div class="yc-content-all-box">

        <a-row type="flex" justify="space-between" align="middle" >

          <a-col :span="5">
            <div class="yc-content-single-box">
              <div class="yc-content-title-text">电池电压</div>
              <div class="yc-content-num-text">
                <span  style="font-size: 220%">75</span>mv
              </div>
            </div>
          </a-col>

          <a-col :span="5">
            <div class="yc-content-single-box">
              <div class="yc-content-title-text">酸碱度</div>
              <div class="yc-content-num-text">
                <span  style="font-size: 220%">7</span>
              </div>
            </div>
          </a-col>

          <a-col :span="5">
            <div class="yc-content-single-box">
              <div class="yc-content-title-text">温度</div>
              <div class="yc-content-num-text">
                <span  style="font-size: 220%">36.2</span>℃
              </div>
            </div>
          </a-col>

          <a-col :span="5">
            <div class="yc-content-single-box">
              <div class="yc-content-title-text">氨氮值</div>
              <div class="yc-content-num-text">
                <span  style="font-size: 220%">91</span>mv
              </div>
            </div>
          </a-col>

        </a-row>

      </div>
    </a-card>

    <a-card class="all-card-style ">
      <!--      筛选条件-->
      <div class="search-box">
        <a-form layout="inline" :form="form" @submit="">

          <a-form-item
            label="展现形式" class="ant-form-item2"
          >
            <a-button-group>
              <a-button @click="showLine">曲线</a-button>
              <a-button @click="showTable">表格</a-button>
            </a-button-group>
          </a-form-item>

          <a-form-item
            label="起止日期" class="ant-form-item2"
          >
            <a-range-picker />
          </a-form-item>

          <a-form-item>
            <a-select default-value="全部" style="width: 120px"  class="ant-form-item2">
              <a-select-option value="1">
                全部
              </a-select-option>
              <a-select-option value="2">
                溶解氧
              </a-select-option>
              <a-select-option value="3">
                PH值
              </a-select-option>
              <a-select-option value="4">
                水温
              </a-select-option>
              <a-select-option value="5">
                压力
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item>
            <a-select default-value="实时曲线" style="width: 120px" class="ant-form-item2" >
              <a-select-option value="1">
                实时曲线
              </a-select-option>
              <a-select-option value="2">
                历史曲线
              </a-select-option>
              <a-select-option value="3">
                早均线
              </a-select-option>
              <a-select-option value="4">
                晚均线
              </a-select-option>
              <a-select-option value="5">
                日均线
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" html-type="submit" class="ant-form-item2">
              查询
            </a-button>
            <span class="button-margin"></span>
            <a-button html-type="submit" >
              导出
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <!--      曲线-->
      <div  v-show="lineVisible">
        <div id="c1"></div>
      </div>

      <!--      表格-->
      <div v-if="tableVisible">
        <a-table :columns="columns" :data-source="data"></a-table>
      </div>
    </a-card>
  </div>
</template>

<script>
  import TitleCard from '@/components/TitleCard.vue'
  import { Chart } from '@antv/g2';


  const columns = [

    {
      title: '设备号',
      dataIndex: 'num',
      key: 'num',
    },
    {
      title: '设备名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '10:30',
      dataIndex: 'time1',
      key: 'time1',
    },
    {
      title: '11:30',
      dataIndex: 'time2',
      key: 'time2',
    },
    {
      title: '12:30',
      dataIndex: 'time3',
      key: 'time3',
    },
    {
      title: '13:30',
      dataIndex: 'time4',
      key: 'time4',
    },
  ];

  const data = [
    {
      key: '1',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },
    {
      key: '2',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },
    {
      key: '3',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },

    {
      key: '4',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },

    {
      key: '5',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },
  ];

  const data2 = [
    { year: '1991', value: 3 },
    { year: '1992', value: 4 },
    { year: '1993', value: 3.5 },
    { year: '1994', value: 5 },
    { year: '1995', value: 4.9 },
    { year: '1996', value: 6 },
    { year: '1997', value: 7 },
    { year: '1998', value: 9 },
    { year: '1999', value: 13 },
  ];

  export default {
    name: 'intelligentPrediction',
    components: {

    },
    mounted() {
      this.createLine()
    },
    data() {
      return {
        form: this.$form.createForm(this),
        lineVisible:true,
        tableVisible:false,
        columns,
        data,
        data2,
        chart: {},
      }
    },
    methods:{
      showLine:function(){
        this.lineVisible=true;
        this.tableVisible=false;
        // this.reloadDrawing()

      },
      showTable:function () {
        // this.reloadDrawing();

        this.lineVisible=false;
        this.tableVisible=true;

      },
      createLine:function(){
        // Step 1: 创建 Chart 对象
        this.chart = new Chart({
          container: 'c1',
          autoFit: true,
          width: 800,
          height: 300,
        });

        // Step 2: 载入数据源
        this.chart.data(data2);

        // Step 3：创建图形语法，绘制柱状图
        // this.chart.interval().position('genre*sold');
        this.chart.scale({
          year: {
            range: [0, 1],
          },
          value: {
            min: 0,
            nice: true,
          },
        });
        this.chart.tooltip({
          showCrosshairs: true, // 展示 Tooltip 辅助线
          shared: true,
        });
        this.chart.line().position('year*value').label('value');
        this.chart.point().position('year*value');

        // Step 4: 渲染图表
        this.chart.render();
      },

      reloadDrawing:function() {
        //销毁画布对象
        this.chart.destroy();
        //重新调用数据进行加载
        this.createLine();
      }


    },


  }
</script>


<style>
  @import "../equipmentDetailsStyle.css";

  .yc-title{
    font-size: 105%;
    font-weight: bold;
  }

  .yc-content-single-box{
    border: 1px solid #e2e2e2;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 25px 0px;
  }

  .yc-content-all-box{
    margin-top: 24px;
  }

  .yc-content-title-text{

  }

  .yc-content-num-text{
    color: #1890ff;
  }
</style>


